import { render, staticRenderFns } from "./SMarkdown.vue?vue&type=template&id=0b9dbfec&scoped=true&"
import script from "./SMarkdown.vue?vue&type=script&lang=js&"
export * from "./SMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./SMarkdown.vue?vue&type=style&index=0&id=0b9dbfec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dbfec",
  null
  
)

export default component.exports